//created by Peggy on 2021/3/31
import React, { useRef, useState, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";

import {
    Button,
    Divider,
    Form,
    Input,
    InputNumber,
    message,
    Radio,
    Select,
    Spin,
} from "antd";

import StripePayCom from "@/components/StripePayment";

import { recurring_change, recurring_cancel } from "@/api/payment-api";

import { ReactComponent as CreditCard } from "@/images/credit_card.svg";
import { ReactComponent as PayPal } from "@/images/paypal.svg";
import styled from "styled-components";


import HomeLayout from "@/components/layouts/HomeLayout";

import "@/styles/home/donation.less";
import { Steps } from "antd";
import DonationInput from "@/pages/homepage/donation/DonationInput";
import { capturePayPal, createPayPal, crowGet, donationMonthSubscribePayPalCheck, getBillInfo } from "@/api/donation-api";
import { useModel } from 'use-reaction'
import { donation, saveDonation } from '@/model/donation'
import TotalCard from "@/pages/homepage/donation/TotalCard";
import { LockFilled } from "@ant-design/icons";
import { getToken } from "@/utils/storage";
import { stateList } from "@/types/enum";
import IsThisCorrect from "@/pages/homepage/donation/IsThisIncorrect";
import { user } from "@/model/user";
const { getData: getCountryList } = require('country-list');
const countryList = getCountryList()

const DonationContainer = styled.div``;

type Info = {
    id: number,
    productType: 'donation' | 'sponsorship',
    frequency: 'once' | 'month' | 'year',
    receiverName: string,
    amount: string,
    paymentMethod: 'card' | 'paypal'
    nextCharge: string, // Date string
    createDate: string, // Date string
    artist?: {
        id: number,
        firstName: string,
        lastName: string,
        displayName: string,
        avatar: string,
        feeRate: string,
        tags: string[]
    },
    crowdfundingId?: number
}

export const RecurringChange = () => {
    const history = useHistory();
    const info: Info = history.location.state as Info;

    let _type = info.crowdfundingId ? 'crowd' : info.artist?.id ? 'general' : 'field'
    const _id = (info.crowdfundingId || info.artist?.id || '') + ''

    if (!info.artist) {
        info.artist = {
            id: undefined as any,
            displayName: 'Counterpart',
            firstName: 'Counterpart',
            lastName: '',
            avatar: '',
            feeRate: '0',
            tags: []
        }
    }

    const [step, setStep] = useState(0)
    const [orderId, setOrderId] = useState(0)
    const [recurringDate, setRecurringDate] = useState(new Date())
    const onOrder = (orderId: string) => {
        setOrderId(+orderId)
        setStep(1)
    }
    return (
        <HomeLayout>
            <DonationContainer className="donation-container">
                <h1>Support {info.artist.displayName}</h1>
                <h2>You are updating your recurring donation.</h2>
                <Steps current={step ? Number(step) : 0}>
                    <Steps.Step title="Donation detail" />
                    <Steps.Step title="Payment" />
                </Steps>
                <div className="donation-info flex align-start">
                    {step === 0 ? (
                        <DonationInput
                            artistInfo={{ artist: info.artist }}
                            _id={_id}
                            _type={_type}
                            pickDate={d => d && setRecurringDate(d.toDate())}
                            onNext={(url?: string) => onOrder(url!.split('/').pop()!)}
                            hideOnetime
                        />
                    ) : (
                        <DonationPay
                            artistInfo={{ artist: info.artist }}
                            type={_type}
                            subscriptionId={info.id}
                            payId={orderId}
                            recurringDate={recurringDate}
                            onNext={() => history.goBack()}
                        />
                    )}
                </div>
            </DonationContainer>
        </HomeLayout>
    );
};



const DonationPayContainer = styled.div``;
const Mask = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 9;
  .content-wrap {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #fff;
    font-size: 18px;
    text-transform: uppercase;
    .checkout-logo {
      margin-bottom: 24px;
    }
    span {
      text-decoration: underline;
      display: inline-block;
      margin-right: 24px;
      cursor: pointer;
    }
  }
`;

interface Props {
    artistInfo?: any;
    onNext?: () => void;
    type?: string;
    subscriptionId: number
    payId: number
    recurringDate: Date
}

const StripePay = React.forwardRef<any, any>((props, ref) => (
    <StripePayCom {...props} submitRef={ref} />
));

let _page: any = null;

const DonationPay = ({ onNext, type = "general", artistInfo = {}, subscriptionId, payId, recurringDate }: Props) => {
    const history = useHistory();
    const submitRef = useRef<any>(null);
    const [form] = Form.useForm();
    const { store: userStore } = useModel(user);
    const { doAction, resetModel, store } = useModel(donation);
    const [pay, setPay] = useState<any>({
        payment: "credit card",
        address: "",
        email: "",
        name: "",
        city: "",
        state: "",
        country: "US",
        code: "",
    });

    const [paying, setPaying] = useState(false);
    const onFinish = async (values: any) => {
        setPaying(true);
        await setPay({ ...pay, ...values });
        await submitRef?.current?.submit();
    };

    const onFinishFailed = (e: any) => {
        setPaying(false);
        console.log("Failed:", e);
        message.error(e.errorFields[0].errors[0]);
    };

    //loading
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        setTimeout(() => {
            setLoading(false);
        }, 2000);
    }, []);

    //render payPal button - one time
    useEffect(() => {
        (window as any)?.paypal
            ?.Buttons({
                createOrder: async () => {
                    let data: any = await createPayPal({
                        id: payId,
                    });
                    return data?.result?.id;
                },
                onApprove: async () => {
                    let data = await capturePayPal({
                        id: payId,
                    });
                    if (data.success) {
                        history.push(`/home/donation/success/${payId}`);
                    } else {
                        message.error(data?.error);
                        // console.error(data.error);
                    }
                    return data;
                },
                onError: (err: any) => {
                    // For example, redirect to a specific error page
                    console.log(err);
                },
            })
            .render("#paypal-button-wrapper");
        // eslint-disable-next-line
    }, []);

    //payPal - month
    const [checkPaypal, setCheckPaypal] = useState("");
    const payPalCharge = async () => {
        const _data = await recurring_change({
            orderId: payId,
            recurringDate,
        }, 'paypal');
        setCheckPaypal(_data.id);
        window.open(
            _data.links[0].href,
            "",
            "height=606,width=400,top=200,left=400,toolbar=no,menubar=no,scrollbars=no, resizable=no,location=no, status=no"
        );
    };
    const checkPay = () => {
        donationMonthSubscribePayPalCheck({
            id: checkPaypal,
        }).then((data) => {
            if (data.warning) {
                message.warn(data.warning);
            }
            _page?.close();
            setCheckPaypal("");
            history.push(`/home/donation/success/${payId}`);
        });
    };

    useEffect(() => {
        let { amount, otherAmount, fieldAmount, ...others } = store;
        doAction(saveDonation, {
            ...others,
            tAmount: Number(amount || otherAmount || 0).toFixed(2) || 0.0,
            amount: Number(amount).toFixed(2) || 0.0,
            otherAmount: Number(otherAmount).toFixed(2) || 0.0,
            fieldAmount: Number(fieldAmount).toFixed(2) || 0.0,
        });
        if (getToken()) {
            getBillInfo({}, true).then((data) => {
                const {
                    billing_details: {
                        address: { city, line1: address, postal_code: code, state, country },
                        ...others
                    },
                } = (Object.values(data)?.length && data) || {
                    billing_details: {
                        address: {
                            city: "",
                            line1: "",
                            postal_code: "",
                            state: "",
                            country: "US",
                        },
                    },
                };
                let _pay = {
                    ...pay,
                    ...others,
                    city,
                    address,
                    code,
                    state,
                    country: country || 'US',
                    name:(userStore.info.firstName + ' ' + userStore.info.lastName).trim(),
                    email:userStore.info.email
                };
                setPay(_pay);
                form.setFieldsValue(_pay);
            });
        }
        // eslint-disable-next-line
    }, []);

    return (
        <>
            {loading && <Spin className="global-spin-container"></Spin>}
            <DonationPayContainer className="donation-pay-container">
                <div className="flex column start align-start">
                    <h2>Payment method</h2>
                    <Radio.Group
                        defaultValue="credit card"
                        className="card-radio"
                        size="large"
                        onChange={(e) => {
                            setPay({
                                ...pay,
                                payment: e.target.value,
                            });
                        }}
                    >
                        <Radio.Button value="credit card">
                            <CreditCard />
                            Credit card
                        </Radio.Button>
                        {/* <Radio.Button value="payPal">
                            <PayPal />
                            PayPal
                        </Radio.Button> */}
                    </Radio.Group>
                </div>

                {pay.payment === "credit card" && (
                    <>
                        <Divider />
                        <h2>Credit card information</h2>
                        <StripePay
                            payType='recurringChange'
                            recurringData={{ recurringDate }}
                            payId={payId}
                            payInfo={{ ...pay }}
                            ref={submitRef}
                            setPaying={setPaying}
                            onNext={() => {
                                setPaying(false);
                                message.success('payment updated!')
                                recurring_cancel({ id: subscriptionId, email: false }).then(_ => {
                                    onNext && onNext()
                                })
                            }}
                        />
                        <Divider />
                        <h2>Billing information </h2>
                        <IsThisCorrect isStep2/>
                        <Form
                            layout="vertical"
                            size="large"
                            name="basic"
                            form={form}
                            initialValues={pay}
                            onFinish={onFinish}
                            onFinishFailed={onFinishFailed}
                            onValuesChange={(val) => {
                                if (val.country) {
                                    form.setFieldsValue({ state: '', code:'' })
                                }
                            }}
                        >
                            <Form.Item
                                label="Full Name"
                                name="name"
                                rules={[
                                    {
                                        required: true,
                                        whitespace: true,
                                        message: "Enter full Name",
                                    },
                                ]}
                            >
                                <Input disabled={!!userStore.token} size="large" placeholder="Enter full Name" />
                            </Form.Item>
                            <Form.Item
                                label="Email address"
                                name="email"
                                rules={[
                                    {
                                        required: true,
                                        type: "email",
                                        message: "Enter Email address",
                                    },
                                ]}
                            >
                                <Input disabled={!!userStore.token} size="large" placeholder="Enter Email address" />
                            </Form.Item>
                            <Form.Item
                                label="Billing Address"
                                name="address"
                                rules={[
                                    {
                                        required: true,
                                        whitespace: false,
                                        message: "Enter billing address",
                                    },
                                ]}
                            >
                                <Input size="large" placeholder="Address" />
                            </Form.Item>
                            <Form.Item
                                label="Country"
                                name="country"
                                rules={[
                                    {
                                        required: true,
                                        whitespace: true,
                                        message: "Choose Country",
                                    },
                                ]}
                            >
                                <Select
                                    showSearch
                                    size="large"
                                    placeholder="Country"
                                    optionFilterProp="label"
                                    options={countryList.map((item:any) => ({
                                      value:item.code,label:item.name
                                    }))}
                                  />
                            </Form.Item>
                            <Form.Item
                                label="City"
                                name="city"
                                rules={[
                                    {
                                        required: true,
                                        whitespace: true,
                                        message: "Enter city",
                                    },
                                ]}
                            >
                                <Input size="large" placeholder="City" />
                            </Form.Item>
                            
                            <div className="flex start align-start row-flex">
                                <Form.Item noStyle dependencies={['country']}>
                                    {
                                        ({ getFieldValue }) => {
                                            return getFieldValue('country') === 'US' ?
                                                <Form.Item
                                                    label="State"
                                                    name="state"
                                                    className="select-item"
                                                    rules={[
                                                        {
                                                            required: true,
                                                            whitespace: false,
                                                            message: "Select State",
                                                        },
                                                    ]}
                                                >

                                                    <Select
                                                        showSearch
                                                        size="large"
                                                        placeholder="State"
                                                    >
                                                        {Object.values(stateList)?.map((item) => (
                                                            <Select.Option value={item} key={item}>
                                                                {item}
                                                            </Select.Option>
                                                        ))}
                                                    </Select>
                                                </Form.Item> :
                                                <Form.Item
                                                    label="State/Province"
                                                    name="state"
                                                    rules={[
                                                        {
                                                            required: true,
                                                            whitespace: true,
                                                            message: "Enter State",
                                                        },
                                                    ]}
                                                >
                                                    <Input size="large" placeholder="State" />
                                                </Form.Item>
                                        }
                                    }
                                </Form.Item>
                                <Form.Item noStyle dependencies={["country"]}>
                                    {({ getFieldValue }) => {
                                        return getFieldValue("country") === "US" ? (
                                        <Form.Item
                                        label="Zip Code/Postal Code"
                                        name="code"
                                        rules={[
                                            {
                                            required: true,
                                            whitespace: true,
                                            message: 'Please enter your 5-digit zip code.',
                                            validator: (_, value) => {
                                                if(/(^\d{5}$)/.test(value)){
                                                return Promise.resolve()
                                                }else{
                                                return Promise.reject()
                                                }
                                            }
                                            },
                                        ]}
                                        >
                                        <Input style={{width:'100%'}} onBeforeInput={(e:any) => {
                                            if (!/^\d*$/.test(e.data)) {
                                                e.preventDefault();
                                            }
                                            }} maxLength={5} placeholder="Zip Code" />
                                        </Form.Item>
                                        ) : (
                                        <Form.Item
                                        label="Zip Code/Postal Code"
                                        name="code"
                                        rules={[
                                            {
                                            required: true,
                                            whitespace: true,
                                            message: 'Please enter your zip code.'
                                            },
                                        ]}
                                        >
                                        <Input maxLength={10} placeholder="Zip Code" />
                                        </Form.Item>
                                        );
                                    }}
                                    </Form.Item>
                            </div>
                        </Form>
                    </>
                )}

            </DonationPayContainer>
            <TotalCard artistInfo={artistInfo} type={type} hidden>
                <Divider />
                <p className="flex start tips-item">
                    <LockFilled />
                    Be assured that your information is safe with us.
                </p>
                {(pay.payment !== "payPal" || store.frequency !== "once") && (
                    <Button
                        type="primary"
                        disabled={paying}
                        block
                        onClick={() => {
                            if (pay.payment === "payPal") {
                                payPalCharge();
                            } else {
                                form.submit();
                            }
                        }}
                    >
                        update payment
                    </Button>
                )}
                <div
                    id="paypal-button-wrapper"
                    className={`${pay.payment !== "payPal" || store.frequency !== "once"
                        ? "hidden"
                        : ""
                        }`}
                ></div>
            </TotalCard>
            {checkPaypal && (
                <Mask>
                    <div className="content-wrap">
                        <div className="checkout-logo">
                            <img
                                src="data:image/svg+xml;base64,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"
                                alt=""
                                aria-label="PP"
                                className="paypal-logo paypal-logo-pp paypal-logo-color-white"
                            />
                            <img
                                src="data:image/svg+xml;base64,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"
                                alt=""
                                aria-label="PayPal"
                                className="paypal-logo paypal-logo-paypal paypal-logo-color-white"
                            />
                        </div>
                        <span
                            onClick={() => {
                                setCheckPaypal("");
                                _page?.close();
                            }}
                        >
                            unpaid
                        </span>
                        <span onClick={checkPay}>paid</span>
                    </div>
                </Mask>
            )}
        </>
    );
};
